import { useMutation, useQueryClient } from "@tanstack/react-query";
import calendarEventApiClient, {
  CalendarEvent,
} from "../../../api/calendarEvent";

const useUpsertCalendarEventMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      eventId,
      event,
    }: {
      eventId: string;
      event: CalendarEvent;
    }) => {
      return calendarEventApiClient.upsertCalendarEvent(eventId, event);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["calendar-events"],
      });
      queryClient.invalidateQueries({
        queryKey: ["calendar-events-by-date"],
      });
    },
  });
};

export default useUpsertCalendarEventMutation;
